module.exports = __webpack_public_path__ + "img/republic-of-poland.6e10627c.svg";